import React from 'react';

import Header from '../sections/Header';
import Toasts from '../sections/Toasts';
import Users from '../sections/Users';
import Footer from '../sections/Footer';


const Landing = () => (
    <>
        <Header />
        <Toasts />
        <Users />
        <Footer />
    </>
);

export default Landing;